<template>
  <div class="mainContainer">
    <div class="mainContainer-left">
      <el-menu :default-active="activeMenu" class="el-menu-vertical-demo">
        <sysytemSubMenu :menus="routes"></sysytemSubMenu>
      </el-menu>
    </div>
    <div class="mainContainer-right">
      <div class="mainContainer-tab">
        <div class="mainContainer-tab-left"></div>
        <div class="mainContainer-tab-right"></div>
      </div>
      <div class="mainContainer-body">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import routes from "../router";

export default {
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    routes() {
      if (routes && routes.length > 0) {
        return this.handleRoute(routes[1].children);
      } else {
        return [];
      }
    },
  },
  mounted() {},
  methods: {
    handleRoute(data, path) {
      let arr = [];
      data.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children = this.handleRoute(item.children, item.path);
        }
        if (path) {
          let obj = {
            ...item,
            path: path + "/" + item.path,
          };
          arr.push(obj);
        } else {
          arr.push(item);
        }
      });
      return arr;
    },
  },
};
</script>

<style lang="less" scoped>
.mainContainer {
  width: inherit;
  height: 100%;
  display: flex;
  overflow: hidden;
  background-color: white;

  .mainContainer-left {
    height: 100%;
    width: 200px;
  }

  .mainContainer-right {
    height: 100%;
    width: calc(100% - 200px);

    .mainContainer-tab {
      height: 40px;
      width: 100%;
      display: flex;

      .mainContainer-tab-left {
        width: calc(100% - 100px);
        overflow: hidden;
      }

      .mainContainer-tab-right {
        width: 100px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .mainContainer-body {
      width: calc(100% - 32px);
      height: calc(100% - 64px);
      background-color: #f3f5f9;
      padding: 8px 16px 16px;
      overflow: hidden;
    }
  }
}

#portalContainer {
  width: 100%;
  height: 100%;

  > div {
    width: 100%;
    height: 100%;
  }
}
</style>
